export enum TipoPerfil {
  ADM = 'ADMINISTRADOR',
  SEECT = 'SEECT',
  PROFESSOR = 'PROFESSOR',
}
